import React from 'react'

type LoaderProps = {
  isComponent?: boolean
}

const Loader: React.FC<LoaderProps> = () => {
  return (
    <div
      data-testid='login-page'
      className={`flex items-center  justify-center w-full h-full bg-primary dark:bg-[#1A334F]`}
    >
      <div className='loading flex justify-center items-center w-[100px] h-[100px] gap-[6px]'>
        <span className='block w-[4px] h-[50px] bg-[#D5122F] dark:bg-[#FF4D6A] animate-scale delay-800'></span>
        <span className='block w-[4px] h-[50px] bg-[#A31764] dark:bg-[#D73A8A] animate-scale delay-700'></span>
        <span className='block w-[4px] h-[50px] bg-[#551BA5] dark:bg-[#7B3FD1] animate-scale delay-600'></span>
        <span className='block w-[4px] h-[50px] bg-[#551BA5] dark:bg-[#0037FF] animate-scale delay-500'></span>
      </div>
    </div>
  )
}

export default Loader
